/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import core, { App } from '@gin-betting/core';

import { SidebarView } from 'app-constants';
import {
    CHANGE_FAVORITE_COUNT,
    CHANGE_ODD_FORMAT,
    CHANGE_ODDS_STATISTIC,
    CHANGE_SIDEBAR_VIEW,
    CLOSE_FILTER,
    CLOSE_SIDEBAR,
    DISABLE_ODD_HISTORY,
    ENABLE_ODD_HISTORY,
    OPEN_FILTER,
    OPEN_SIDEBAR,
    SET_ACTIVE_MOBILE_COUNTRY_KEY,
    SET_ODDS_CHANGE_MODAL_SHOWN,
} from './constants';
import { FavoriteCountType } from './types';

const { makeAction } = core.utils;

export function changeOddFormat(payload: { oddFormat: App.OddFormat }) {
    return makeAction(CHANGE_ODD_FORMAT, payload);
}

export function changeFavoriteCount(payload: {
    count: number;
    type: FavoriteCountType;
}) {
    return makeAction(CHANGE_FAVORITE_COUNT, payload);
}

export function changeSidebarView(payload: { sidebarView: SidebarView }) {
    return makeAction(CHANGE_SIDEBAR_VIEW, payload);
}

export const enableOddHistory = () => makeAction(ENABLE_ODD_HISTORY);
export const disableOddHistory = () => makeAction(DISABLE_ODD_HISTORY);
export const toggleOddHistory = ({ isEnable }: { isEnable: boolean }) =>
    isEnable ? disableOddHistory() : enableOddHistory();

export const openSidebar = () => makeAction(OPEN_SIDEBAR);
export const closeSidebar = () => makeAction(CLOSE_SIDEBAR);
export const toggleSidebar = ({ isOpen }: { isOpen: boolean }) =>
    isOpen ? openSidebar() : closeSidebar();

export function changeOddsStatisticView(payload: {
    statisticView?: App.OddStatisticView;
    show?: boolean;
}) {
    return makeAction(CHANGE_ODDS_STATISTIC, payload);
}

export const openFilter = () => makeAction(OPEN_FILTER);
export const closeFilter = () => makeAction(CLOSE_FILTER);

export const setActiveMobileCountryKey = (nextCountryKey: string) =>
    makeAction(SET_ACTIVE_MOBILE_COUNTRY_KEY, nextCountryKey);

export const setOddsChangeModalShown = (value: boolean | undefined = true) =>
    makeAction(SET_ODDS_CHANGE_MODAL_SHOWN, value);

export const Actions = {
    changeOddFormat,
    toggleOddHistory,
    changeSidebarView,
    changeFavoriteCount,
    changeOddsStatisticView,
    openSidebar,
    closeSidebar,
    toggleSidebar,
    openFilter,
    closeFilter,
    setActiveMobileCountryKey,
    setOddsChangeModalShown,
};

/* eslint-disable  */
export type Actions = App.ActionsUnion<typeof Actions>;
